import React, { useState, useEffect } from 'react'; // Added useState
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../Utils/_helpers";
// import { Tracker } from "../../../../../../util/analytics"; // Assuming not directly needed for this change
// import { getUser } from "../../../../../../util/helpers"; // Assuming not directly needed for this change
import * as configuration from "../../../../_redux/state/configurationRedux";

// It's good practice to define the props the component expects
interface ConfigurationSideBarProps {
  onSelectReportType: (reportType) => void; // Callback to parent
}

export default function ConfigurationSideBar({ onSelectReportType }: ConfigurationSideBarProps) {
  const dispatch = useDispatch();
  const categories = useSelector((state) => { // Added 'any' for state type, be more specific if possible
    return state.configuration.callCategories;
  });

  // State to manage the active tab
  const [activeReport, setActiveReport] = useState("standard"); // Default to 'standard'

  useEffect(() => {
    if (categories && categories.results && categories.results.length > 0) {
      // You might want to reconsider auto-selecting a generic category
      // if the sidebar is also managing specific report type selections.
      // For now, let's assume this logic is still desired.
      dispatch(
        configuration.actions.callSelectedGenericCategory(categories.results[0])
      );
    }
  }, [categories, dispatch]);

  const handleReportTypeClick = (reportType) => {
    setActiveReport(reportType);
    onSelectReportType(reportType); // Notify parent
    // You could also dispatch a Redux action here if needed,
    // for example, to fetch data for the selected report type.
    // Tracker.track("Report Type Selected", { reportType }); // Example analytics
  };

  return (
    <div
      className="card w-100"
      style={{
        backgroundColor: "#fff",
        height: "calc(100vh)",
        position: "sticky",
        top: "0px",
        overflowY: "auto", // Added in case content grows
      }}
    >
      <div
        style={{ fontSize: "16px", fontWeight: 500, margin: "32px 0 0 20px" }}
      >
        Select Reports
      </div>
      <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
        <div style={{ marginLeft: "20px", marginRight: "20px" }}> {/* Added marginRight for consistency */}
          {/* Standard Reports */}
          <div
            className={`configuration-sidebar-item ${activeReport === "standard" ? "active" : ""}`}
            style={{
              cursor: "pointer",
              marginBottom: "10px",
              padding: "10px", // Added padding for better click area and appearance
              borderRadius: "4px", // Optional: for rounded corners
              display: "flex", // For aligning items
              justifyContent: "space-between", // For aligning text and ">"
              alignItems: "center", // For vertical alignment
            }}
            onClick={() => handleReportTypeClick("standard")}
            onKeyDown={(e) => e.key === 'Enter' && handleReportTypeClick("standard")} // Accessibility
            role="button" // Accessibility
            tabIndex={0} // Accessibility
          >
            <div className="d-flex align-items-center"> {/* Ensure icon and text align */}
              <img
                src={toAbsoluteUrl("/media/sr/icons/report-4.png")} // Standard report icon
                alt=""
                style={{ height: "19px", marginRight: "10px" }}
              />
              Standard Reports
            </div>
            <div>{activeReport === "standard" && ">"}</div> {/* Show ">" only if active or always, based on preference */}
          </div>

          {/* Call Log Reports */}
          <div
            className={`configuration-sidebar-item ${activeReport === "callLog" ? "active" : ""}`}
            style={{
              cursor: "pointer",
              marginBottom: "10px",
              padding: "10px", // Added padding
              borderRadius: "4px", // Optional
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={() => handleReportTypeClick("callLog")}
            onKeyDown={(e) => e.key === 'Enter' && handleReportTypeClick("callLog")} // Accessibility
            role="button" // Accessibility
            tabIndex={0} // Accessibility
          >
            <div className="d-flex align-items-center"> {/* Ensure icon and text align */}
              <img
                src={toAbsoluteUrl("/media/sr/icons/report-4.png")} // Placeholder icon, replace with actual
                alt=""
                style={{ height: "22px", marginRight: "10px" }}
              />
              Call Log Reports
            </div>
            <div>{activeReport === "callLog" && ">"}</div> {/* Show ">" only if active */}
          </div>
        </div>
      </div>
    </div>
  );
}